import gql from 'graphql-tag';

export const CHECK_IS_SWITCH_ACCOUNTS_ENABLED = gql`
  query CheckIsSwitchAccountsEnabled {
    additionalAccount {
      result: checkSwitchAdditionalAccount {
        error
        entity
        success
      }
    }
  }
`;
